
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarAntennaPositionIec as ObiRadarAntennaPositionIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-antenna-position-iec.js';
 
 
 

 
 export const ObiRadarAntennaPositionIec = createComponent({
   react: React,
   tagName: 'obi-radar-antenna-position-iec',
   elementClass: ObiRadarAntennaPositionIecElement,
   events: {
     
   }
  });
 
 